import React from 'react';
import { Check, Zap, Gift, Clock, ShieldCheck, Download } from 'lucide-react';
import { PremiumCTAButton } from './ui/PremiumCTAButton';
import { motion } from 'framer-motion';
export function BundleOfferSection() {
  const bonusBooks = ['Enfoque sin Estrés', 'Protege tu Enfoque', 'Plan de Arranque: Empieza Ya', 'Enfoque sin Distracción', 'Reuniones Efectivas sin Caos', 'Sistema Anticaos de Mensajes'];
  return <section className="py-20 md:py-32 bg-gradient-to-br from-dark-900 via-black to-dark-900 relative overflow-hidden" data-id="element-1">
      {/* Animated background elements */}
      <div className="absolute inset-0" data-id="element-2">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-px bg-gradient-to-r from-transparent via-gold-500 to-transparent" data-id="element-3"></div>
        <motion.div className="absolute top-1/4 right-0 w-96 h-96 bg-gold-500/10 rounded-full blur-[120px]" animate={{
        scale: [1, 1.2, 1],
        opacity: [0.1, 0.15, 0.1]
      }} transition={{
        duration: 4,
        repeat: Infinity
      }} data-id="element-4" />
        <motion.div className="absolute bottom-1/4 left-0 w-96 h-96 bg-cyan-500/10 rounded-full blur-[120px]" animate={{
        scale: [1, 1.3, 1],
        opacity: [0.1, 0.15, 0.1]
      }} transition={{
        duration: 5,
        repeat: Infinity,
        delay: 1
      }} data-id="element-5" />
      </div>

      <div className="max-w-7xl mx-auto px-4 relative z-10" data-id="element-6">
        {/* Launch Badge */}
        <motion.div className="text-center mb-8" initial={{
        opacity: 0,
        y: -20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-7">
          <div className="inline-flex items-center gap-3 px-6 py-3 rounded-full bg-gradient-to-r from-red-500/20 via-orange-500/20 to-yellow-500/20 border-2 border-orange-500/50 backdrop-blur-sm mb-6" data-id="element-8">
            <Zap className="w-6 h-6 text-orange-500 animate-pulse" data-id="element-9" />
            <span className="text-orange-500 font-bold uppercase tracking-wider text-lg" data-id="element-10">
              🚀 OFERTA DE LANZAMIENTO
            </span>
            <Zap className="w-6 h-6 text-orange-500 animate-pulse" data-id="element-11" />
          </div>
        </motion.div>

        {/* Main Headline */}
        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} data-id="element-12">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-serif font-bold mb-4 leading-tight" data-id="element-13">
            <span className="text-white" data-id="element-14">SOLO </span>
            <span className="text-gradient-gold text-5xl md:text-7xl" data-id="element-15">
              $9.95
            </span>
          </h2>
          <h3 className="text-2xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-16">
            ADIÓS AL CAOS POR EL ESTRÉS LABORAL
          </h3>
          <p className="text-xl md:text-2xl text-gray-300 font-light max-w-3xl mx-auto" data-id="element-17">
            El Método CIERRE 90' para recuperar control, enfoque y calma mental
          </p>
        </motion.div>

        {/* Problem Statement */}
        <motion.div className="max-w-3xl mx-auto text-center mb-12" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} data-id="element-18">
          <p className="text-lg md:text-xl text-gray-300 leading-relaxed mb-4" data-id="element-19">
            Trabajas todo el día, pero terminas sin haber cerrado nada.
            <span className="text-white font-semibold" data-id="element-20">
              {' '}
              No es cansancio. Es ruido mental.
            </span>
          </p>
          <p className="text-lg md:text-xl text-gray-400" data-id="element-21">
            Este pack no es motivación. Es un sistema simple para cerrar
            pendientes en medio del caos laboral.
          </p>
        </motion.div>

        {/* Main Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 mb-16 max-w-6xl mx-auto" data-id="element-22">
          {/* Left: Book Image */}
          <motion.div className="relative" initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} data-id="element-23">
            <div className="relative bg-gradient-to-br from-gold-500/10 to-yellow-500/5 border-2 border-gold-500/30 rounded-3xl p-8 md:p-12" data-id="element-24">
              {/* Glow effect */}
              <div className="absolute inset-0 bg-gold-500/20 blur-[80px] rounded-full" data-id="element-25"></div>

              <img src="https://cdn.magicpatterns.com/uploads/nVi5D7PkQzVXACwNVXfAGp/EBOOK_PRINCIPAL.png" alt="Adiós al Caos - Libro Principal" className="relative w-full h-auto drop-shadow-2xl transform hover:scale-105 transition-transform duration-500" data-id="element-26" />

              {/* Badge */}
              <div className="absolute -top-4 -right-4 bg-gradient-to-r from-green-500 to-emerald-500 text-white px-6 py-3 rounded-full text-sm font-bold uppercase shadow-xl transform rotate-6" data-id="element-27">
                + 6 BONOS GRATIS
              </div>
            </div>
          </motion.div>

          {/* Right: What You Get */}
          <motion.div className="flex flex-col justify-center" initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.5
        }} data-id="element-28">
            <div className="bg-dark-800/50 border border-gold-500/20 rounded-2xl p-6 md:p-8 backdrop-blur-sm" data-id="element-29">
              <div className="flex items-center gap-3 mb-6" data-id="element-30">
                <Gift className="w-8 h-8 text-gold-500" data-id="element-31" />
                <h3 className="text-2xl md:text-3xl font-bold text-white" data-id="element-32">
                  📦 QUÉ RECIBES HOY
                </h3>
              </div>

              {/* Main Book */}
              <div className="mb-6 pb-6 border-b border-white/10" data-id="element-33">
                <div className="flex items-start gap-3 mb-2" data-id="element-34">
                  <Check className="w-6 h-6 text-gold-500 flex-shrink-0 mt-1" data-id="element-35" />
                  <div data-id="element-36">
                    <p className="text-white font-bold text-lg mb-1" data-id="element-37">
                      Ebook principal: Adiós al Caos por el Estrés Laboral
                    </p>
                    <p className="text-gray-400 text-sm" data-id="element-38">
                      Sistema visual de productividad de alto nivel.
                    </p>
                  </div>
                </div>
              </div>

              {/* Bonus Books */}
              <div className="mb-6" data-id="element-39">
                <p className="text-white font-bold mb-4 flex items-center gap-2" data-id="element-40">
                  <Check className="w-5 h-5 text-green-500" data-id="element-41" />6 ebooks de bono
                  GRATIS, incluyendo:
                </p>
                <div className="grid grid-cols-1 gap-2 ml-8" data-id="element-42">
                  {bonusBooks.map((bonus, index) => <div key={index} className="flex items-center gap-2 text-gray-300 text-sm" data-id="element-43">
                      <div className="w-1.5 h-1.5 bg-gold-500 rounded-full" data-id="element-44"></div>
                      <span data-id="element-45">{bonus}</span>
                    </div>)}
                </div>
              </div>

              {/* Method Highlight */}
              <div className="bg-gradient-to-r from-gold-500/10 to-yellow-500/10 border border-gold-500/30 rounded-xl p-4 mt-6" data-id="element-46">
                <div className="flex items-center gap-2 mb-2" data-id="element-47">
                  <Clock className="w-5 h-5 text-gold-500" data-id="element-48" />
                  <p className="text-gold-500 font-bold" data-id="element-49">
                    ⏱️ EL MÉTODO CIERRE 90'
                  </p>
                </div>
                <p className="text-white text-sm mb-2" data-id="element-50">
                  Un bloque. Una tarea clave. Un timer. Cierre real.
                </p>
                <p className="text-gray-400 text-xs italic" data-id="element-51">
                  Menos estrés no por descansar más, sino por cerrar lo que
                  importa.
                </p>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Pricing Section */}
        <motion.div className="max-w-4xl mx-auto mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} data-id="element-52">
          <div className="bg-gradient-to-br from-dark-800 to-dark-900 border-2 border-gold-500/30 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-53">
            {/* Animated glow */}
            <motion.div className="absolute inset-0 bg-gradient-to-r from-gold-500/5 via-yellow-500/10 to-gold-500/5" animate={{
            x: ['-100%', '100%']
          }} transition={{
            duration: 3,
            repeat: Infinity,
            ease: 'linear'
          }} data-id="element-54" />

            <div className="relative z-10" data-id="element-55">
              <p className="text-gold-500 font-bold text-lg mb-4 flex items-center justify-center gap-2" data-id="element-56">
                <Zap className="w-5 h-5" data-id="element-57" />
                💰 PRECIO ESPECIAL
              </p>

              <div className="flex items-center justify-center gap-6 mb-6" data-id="element-58">
                <div className="text-left" data-id="element-59">
                  <p className="text-gray-400 text-sm mb-1" data-id="element-60">
                    Valor real del pack:
                  </p>
                  <p className="text-3xl text-gray-500 line-through" data-id="element-61">$250.00</p>
                </div>

                <div className="text-6xl text-gold-500 font-bold" data-id="element-62">→</div>

                <div className="text-left" data-id="element-63">
                  <p className="text-orange-500 font-bold text-sm mb-1 flex items-center gap-1" data-id="element-64">
                    🔥 HOY:
                  </p>
                  <p className="text-6xl md:text-7xl font-bold text-gradient-gold" data-id="element-65">
                    $9.95
                  </p>
                  <p className="text-gray-400 text-sm mt-1" data-id="element-66">USD</p>
                </div>
              </div>

              <div className="inline-block bg-green-500/20 border border-green-500/50 rounded-full px-6 py-2 mb-6" data-id="element-67">
                <p className="text-green-400 font-bold" data-id="element-68">
                  Ahorras $240.05 (96% OFF)
                </p>
              </div>

              <p className="text-gray-300 text-lg mb-2" data-id="element-69">
                Un solo pago. Acceso inmediato.
              </p>
            </div>
          </div>
        </motion.div>

        {/* Ideal Para Section */}
        <motion.div className="max-w-4xl mx-auto mb-8" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.65
      }} data-id="element-70">
          <div className="bg-gradient-to-br from-dark-800/80 to-dark-900/80 border border-gold-500/20 rounded-2xl p-6 md:p-8 backdrop-blur-sm" data-id="element-71">
            <div className="flex items-center gap-3 mb-4" data-id="element-72">
              <span className="text-3xl" data-id="element-73">💼</span>
              <h3 className="text-xl md:text-2xl font-bold text-white" data-id="element-74">
                Ideal para:
              </h3>
            </div>
            <p className="text-gray-300 text-base md:text-lg leading-relaxed" data-id="element-75">
              Profesionales, freelancers, emprendedores y cualquier persona que
              trabaja desde casa, estudiantes o en oficina digital y busca{' '}
              <span className="text-gold-500 font-bold text-lg md:text-xl bg-gold-500/10 px-2 py-1 rounded" data-id="element-76">
                productividad real sin burnout
              </span>
              .
            </p>
          </div>
        </motion.div>

        {/* Entrega Instantanea */}
        <motion.div className="max-w-4xl mx-auto mb-10" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.68
      }} data-id="element-77">
          <div className="bg-gradient-to-r from-green-500/10 to-emerald-500/10 border border-green-500/30 rounded-2xl p-6 md:p-8 text-center" data-id="element-78">
            <div className="flex items-center justify-center gap-3 mb-3" data-id="element-79">
              <Download className="w-6 h-6 text-green-500" data-id="element-80" />
              <h3 className="text-xl md:text-2xl font-bold text-white" data-id="element-81">
                📥 Entrega instantánea
              </h3>
            </div>
            <p className="text-gray-300 text-base md:text-lg" data-id="element-82">
              Descarga inmediata después de tu compra. Formato digital
              compatible con todos tus dispositivos.
            </p>
          </div>
        </motion.div>

        {/* CTA Button */}
        <motion.div className="text-center mb-8" initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.7
      }} data-id="element-83">
          <PremiumCTAButton size="xl" data-id="element-84" />

          <p className="text-gray-300 mt-6 text-lg font-medium" data-id="element-85">
            👉 Descárgalo ahora y recupera el control hoy.
          </p>
        </motion.div>

        {/* Trust Badges */}
        <motion.div className="flex flex-wrap justify-center items-center gap-6 text-sm text-gray-400" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.8
      }} data-id="element-86">
          <div className="flex items-center gap-2" data-id="element-87">
            <Download className="w-4 h-4 text-gold-500" data-id="element-88" />
            <span data-id="element-89">Acceso digital inmediato</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-90">
            <Gift className="w-4 h-4 text-gold-500" data-id="element-91" />
            <span data-id="element-92">Plantillas incluidas</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-93">
            <ShieldCheck className="w-4 h-4 text-gold-500" data-id="element-94" />
            <span data-id="element-95">Garantía de 30 días</span>
          </div>
        </motion.div>

        {/* Social Proof */}
        <motion.div className="mt-12 text-center" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.9
      }} data-id="element-96">
          <div className="inline-flex items-center gap-2 text-green-500 text-sm bg-green-500/10 border border-green-500/30 rounded-full px-6 py-3" data-id="element-97">
            <Check className="w-4 h-4" data-id="element-98" />
            <span className="font-medium" data-id="element-99">
              Más de 5,000 profesionales ya transformaron su productividad
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}